<span [innerHTML]="preamble"></span>
&nbsp;
<span *ngFor="let item of items; let isLast = last">
  <button (click)="itemSelected.emit(item)" class="btn btn-link">
    <span [innerHTML]="equipmentItemService.getName$(item) | async" class="name"></span>
  </button>
  {{ isLast ? "" : " &middot; " }}
</span>
